import "./button.component.styles.scss";

/** This is a description of the foo function. */
const ButtonComponent = ({ children, otherButton, ...props }) => {
  return (
    <div className="button-container">
      <button
        {...props}
        className={`${otherButton ? "otherTypes" : "custom-button-default"}`}
      >
        {children || "Submit"}
      </button>
    </div>
  );
};

export default ButtonComponent;
